import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'service',
  `
    LOAD_USER_SERVICES
    LOAD_USER_SERVICES_DONE

    TOGGLE_USER_SERVICE
    TOGGLE_USER_SERVICE_DONE
  `
);
